import { useContactManagementTranslation, useUserState } from '../../../../ui/hooks';
import { TextCell } from '@juvare/common-data-table-ui/DataTable';
import { Typography } from '@mui/material';
import React from 'react';
export function useGroupColumns() {
    const { t } = useContactManagementTranslation();
    const userState = useUserState();
    return React.useMemo(() => [
        {
            headerLabel: t('panels.groups.name'),
            sortKey: 'name',
            cellFunction: (row) => React.createElement(TextCell, null, row.columns.name),
        },
        {
            headerLabel: t('panels.groups.type'),
            sortKey: 'filterBased',
            cellFunction: (row) => (React.createElement(TextCell, null,
                React.createElement(Typography, { variant: 'body2' }, row.columns.filterBased ? t('panels.groups.filterBased') : t('panels.groups.standard')),
                React.createElement(Typography, { color: 'textSecondary', variant: 'body2', sx: { whiteSpace: 'pre-wrap' } }, `${t('panels.groups.sharedWith')}: ${renderShareWidth(row, userState, t)}`))),
            tableCellSx: {
                display: {
                    xs: 'table-cell',
                    sm: 'none',
                },
            },
        },
        {
            headerLabel: t('panels.groups.type'),
            sortKey: 'filterBased',
            cellFunction: (row) => (React.createElement(TextCell, null, row.columns.filterBased ? t('panels.groups.filterBased') : t('panels.groups.standard'))),
            tableCellSx: {
                display: {
                    xs: 'none',
                    sm: 'table-cell',
                },
            },
        },
        {
            headerLabel: t('panels.groups.sharedWith'),
            cellFunction: (row) => React.createElement(TextCell, null, renderShareWidth(row, userState, t)),
            tableCellSx: {
                display: {
                    xs: 'none',
                    sm: 'table-cell',
                },
            },
        },
    ], [t, userState]);
}
function renderShareWidth(row, userState, t) {
    if (row.columns.visibleToOrgAdmins.length > 0) {
        return t('panels.groups.organizations');
    }
    else if (row.columns.visibleToAnyAdmin) {
        return t('panels.groups.allAdmins');
    }
    else if (userState.id === row.columns.ownerAccountId) {
        return t('panels.groups.myself');
    }
    return t('panels.groups.notShared');
}
